<span class="text-white cursor-pointer red_txt" data-bs-toggle="modal" data-bs-target="#cancelorder_enable_modal">
    Cancel
</span>